import { ServerConfig } from "@/config/config";
import { Sale } from "@/models/base";
import { Axios } from "@/utils/axios";
import { MainActivity } from "@/utils/carpass/main-activity";
import { Observation } from "@/utils/carpass/observation";
import { ObservationStatusResponse } from "@/utils/carpass/observation-status";
import { DossierConfigService } from "./dossier-config-service";
import { ObservationDescription } from "@/utils/carpass/observation-description";
import { ObservationDescriptionResponse } from "@/utils/carpass/observation-description-response";
import { trackEvent } from "@/utils/analytics";

class CarpassServiceClass {
	private readonly url:string = ServerConfig.host + "/carpass";

	public async test(username:string, password:string):Promise<boolean>{
		await Axios.post(`${this.url}/test`, {Username: username, Password: password});
		return true;
	}

	public async getActivities():Promise<MainActivity[]>{
		let result = await Axios.get(`${this.url}/activities`);
		return ((result.data || []) as any[]).map(d=>new MainActivity(d));
	}


	public async postObservation(sale:Sale, observation:Observation):Promise<ObservationStatusResponse>{
		observation.enterpriseOrganisation = DossierConfigService.getCarpassConfig().KboNumber;
		let result = await Axios.post(`${this.url}/observation`, {SaleID: sale.ID, Observation: observation.getJSON()});
		trackEvent("Post carpass observation");
		return new ObservationStatusResponse(result.data);
	}

	public async getObservationStatus(saleId:number):Promise<ObservationStatusResponse>{
		let result = await Axios.get(`${this.url}/observation-status/${saleId}`);
		return new ObservationStatusResponse(result.data);
	}

	public async postObservationCorrection(sale:Sale, observation:Observation):Promise<ObservationStatusResponse>{
		observation.enterpriseOrganisation = DossierConfigService.getCarpassConfig().KboNumber;
		let result = await Axios.post(`${this.url}/observation-correction/${sale.ID}`, {RequestID: sale.CarpassRequestId, Observation: observation.getJSON()});
		trackEvent("Post carpass observation correction");
		return new ObservationStatusResponse(result.data);
	}

	public async postObservationDescription(sale:Sale, description:ObservationDescription):Promise<ObservationDescriptionResponse>{
		let result = await Axios.post(`${this.url}/observation/${sale.ID}/description`, {RequestID: sale.CarpassRequestId, Description: description.getJSON()});
		trackEvent("Post carpass observation description");
		return new ObservationDescriptionResponse(result.data);
	}
}

export const CarpassService = new CarpassServiceClass();
